import { useCallback, useState } from "react";

import { Button } from "reactstrap";
import { PlusIcon } from "@heroicons/react/24/outline";

import PlatformTopupModal from "./PlatformTopupModal";

const PlatformTopupModalButton = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = useCallback(
    () => setModalOpen(!modalOpen),
    [modalOpen, setModalOpen],
  );

  return (
    <div className="create-platform-topup">
      <Button
        color="dark"
        className="d-flex align-items-center me-3"
        onClick={() => setModalOpen(true)}
      >
        <PlusIcon height={20} width={20} className="me-2" />
        Platform Topup
      </Button>
      <PlatformTopupModal
        modalOpen={modalOpen}
        toggleModal={toggleModal}
      ></PlatformTopupModal>
    </div>
  );
};

export default PlatformTopupModalButton;
